import React from 'react';

import './FormLabel.scss';

export interface Props {
  htmlFor?: string;
}

const FormLabel: React.FC<Props> = ({ children, htmlFor }) => {
  return (
    <label className="form-label" htmlFor={htmlFor}>
      {children}
    </label>
  );
};

export default FormLabel;
